/* Far Afield PDP policy drawer.
   Intercepts only existing Shipping/Returns page links on the product page.
   Fetches Shopify's canonical page on first open, leaving ordinary navigation
   as the fallback if the page cannot be loaded. No duplicate policy content. */
(() => {
  const selector = '.main-product a[data-fa-policy-drawer]';
  let dialog;
  let lastTrigger;
  let requestVersion = 0;
  const cache = new Map();

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'fa-pdp-policy-drawer';
    dialog.setAttribute('aria-labelledby', 'FaPolicyDrawerTitle');
    dialog.innerHTML = `
      <div class="fa-pdp-policy-drawer__head">
        <h2 id="FaPolicyDrawerTitle"></h2>
        <button type="button" class="fa-pdp-policy-drawer__close" aria-label="Close information">×</button>
      </div>
      <div class="fa-pdp-policy-drawer__body rte" id="FaPolicyDrawerContent"></div>`;
    document.body.appendChild(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => lastTrigger?.focus({ preventScroll: true }));
    return dialog;
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest?.(selector);
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !window.HTMLDialogElement) return;
    event.preventDefault();
    const kind = link.dataset.faPolicyDrawer;
    lastTrigger = link;
    const currentRequest = ++requestVersion;
    const pane = ensureDialog();
    const title = pane.querySelector('#FaPolicyDrawerTitle');
    const body = pane.querySelector('#FaPolicyDrawerContent');
    title.textContent = kind === 'returns' ? 'Returns' : 'Shipping';
    body.textContent = 'Loading information…';
    if (!pane.open) pane.showModal();
    const requestUrl = url.pathname + url.search;
    try {
      if (!cache.has(requestUrl)) {
        const response = await fetch(requestUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load page');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('#MainContent .main-page__content');
        if (!content) throw new Error('Missing Shopify page content');
        cache.set(requestUrl, content.innerHTML);
      }
      // If closed while loading, don't reopen it.
      if (pane.open && lastTrigger === link && currentRequest === requestVersion) body.innerHTML = cache.get(requestUrl);
    } catch (error) {
      if (pane.open && lastTrigger === link && currentRequest === requestVersion) {
        body.replaceChildren();
        const fallback = document.createElement('a');
        fallback.href = link.href;
        fallback.textContent = 'Open full ' + (kind === 'returns' ? 'returns' : 'shipping') + ' information';
        body.appendChild(fallback);
      }
    }
  });
})();
